// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 3: ИИСУС ХРИСТОС
// ============================================================================
// Уровни 27-39 (13 уровней, 39 вопросов)

export const chapter3Translations = {
  name: 'Иисус Христос',
  description: 'Слово стало плотью... Знать Христа - это вечная жизнь',
  
  spiritualWisdom: {
    principle: 'Знать Иисуса Христа - это вечная жизнь',
    scripture: 'Сия же есть жизнь вечная, да знают Тебя, единого истинного Бога, и посланного Тобою Иисуса Христа (Иоанна 17:3)',
    application: 'Каждый аспект жизни Иисуса открывает Бога и питает нашу душу для вечности'
  },
  
  levels: {
    27: {
      name: 'Благовещение',
      challenge: 'Ангел Гавриил был послан Богом в город Галилейский...',
      easy: {
        question: 'Какой ангел возвестил Марии, что она родит Иисуса?',
        options: ['Михаил', 'Гавриил', 'Рафаил', 'Уриил'],
        hint: 'Ангел-вестник Божий',
        funFact: '👼 Гавриил означает Сила Божья - ангел великих благовествований!'
      },
      medium: {
        question: 'Какова была первая реакция Марии на это благовестие?',
        options: [
          'Немедленная радость',
          'Полное неверие',
          'Смущение и вопрос Как будет это?',
          'Страх'
        ],
        hint: 'Практичный и обоснованный вопрос',
        funFact: '🤔 Мария задает логичный вопрос, но сохраняет открытое сердце к Богу!'
      },
      hard: {
        question: 'Чему учит нас покорность Марии воле Божьей?',
        options: [
          'Пассивности перед испытаниями',
          'Вере, которая доверяет, даже не понимая всего',
          'Слепому послушанию',
          'Смирению'
        ],
        hint: 'Речь о доверии Богу даже в неизвестном',
        funFact: '🙏 Да будет Мне по слову твоему - образец доверяющей веры!'
      }
    },
    
    28: {
      name: 'Рождество',
      challenge: 'И родила Сына своего Первенца, и спеленала Его, и положила Его в ясли...',
      easy: {
        question: 'В каком городе родился Иисус?',
        options: ['Назарет', 'Иерусалим', 'Вифлеем', 'Капернаум'],
        hint: 'Город Давида',
        funFact: '🏘️ Вифлеем означает Дом хлеба - Иисус, хлеб жизни!'
      },
      medium: {
        question: 'Кто первым получил весть о рождении?',
        options: [
          'Волхвы',
          'Пастухи в поле',
          'Священники Храма',
          'Семья Марии'
        ],
        hint: 'Простые люди, пасущие стада',
        funFact: '🐑 Бог возвещает сначала смиренным пастухам - Евангелие для всех!'
      },
      hard: {
        question: 'Что символизирует Иисус, рожденный в яслях?',
        options: [
          'Бедность Его родителей',
          'Смирение Бога, склоняющегося к нам',
          'Недостаток места',
          'Сельскую простоту'
        ],
        hint: 'Речь о божественном воплощении в смирении',
        funFact: '👶 Творец вселенной рождается в хлеву - бесконечная любовь!'
      }
    },

    29: {
      name: 'Волхвы с Востока',
      challenge: 'Волхвы с востока пришли в Иерусалим и спросили...',
      easy: {
        question: 'Что привело волхвов к Иисусу?',
        options: ['Ангел', 'Звезда', 'Видение', 'Карта'],
        hint: 'Небесное тело',
        funFact: '⭐ Звезда представляет, что Иисус - свет народов!'
      },
      medium: {
        question: 'Какие дары принесли волхвы?',
        options: [
          'Пищу',
          'Золото, ладан и смирну',
          'Дорогие одежды',
          'Игрушки'
        ],
        hint: 'Три символических и драгоценных дара',
        funFact: '🎁 Золото (царство), ладан (божественность), смирна (жертва) - вся миссия Иисуса!'
      },
      hard: {
        question: 'Что представляют эти языческие волхвы в Божьем плане?',
        options: [
          'Превосходство других религий',
          'Всеобщность спасения, предлагаемого всем народам',
          'Материальное богатство',
          'Древнюю науку'
        ],
        hint: 'Речь об открытии спасения всем народам',
        funFact: '🌍 Волхвы предвосхищают Евангелие, которое достигнет всего мира!'
      }
    },

    30: {
      name: 'Крещение Иисуса',
      challenge: 'Крестившись, Иисус тотчас вышел из воды...',
      easy: {
        question: 'Кто крестил Иисуса?',
        options: ['Петр', 'Иоанн Креститель', 'Андрей', 'Иаков'],
        hint: 'Предтеча Иисуса',
        funFact: '🌊 Иоанн Креститель считал себя недостойным развязать обувь Иисуса!'
      },
      medium: {
        question: 'Что сошло на Иисуса при Его крещении?',
        options: [
          'Свет',
          'Голубь (Святой Дух)',
          'Ангел',
          'Только голос'
        ],
        hint: 'Птица - символ мира',
        funFact: '🕊️ Голубь открывает божественное помазание для начала служения!'
      },
      hard: {
        question: 'Почему безгрешный Иисус крестился?',
        options: [
          'Чтобы подать пример',
          'Чтобы исполнить всякую правду и отождествиться с нами',
          'По религиозному долгу',
          'Чтобы получить прощение'
        ],
        hint: 'Речь о солидарности с грешным человечеством',
        funFact: '❤️ Иисус полностью отождествляется с нами, чтобы лучше спасти нас!'
      }
    },

    31: {
      name: 'Искушение в Пустыне',
      challenge: 'Иисус возведен был Духом в пустыню для искушения от диавола...',
      easy: {
        question: 'Сколько времени постился Иисус в пустыне?',
        options: ['30 дней', '40 дней', '50 дней', '60 дней'],
        hint: 'Библейское число испытания',
        funFact: '🏜️ Как Моисей и Илия, 40 дней интенсивной духовной подготовки!'
      },
      medium: {
        question: 'Как Иисус отверг каждое искушение?',
        options: [
          'Своей силой',
          'Цитируя Писание',
          'Игнорируя сатану',
          'Только молитвой'
        ],
        hint: 'Духовное оружие par excellence',
        funFact: '📖 Написано... - Слово Божье, меч Духа!'
      },
      hard: {
        question: 'Чему учит нас искушение Иисуса о наших борьбах?',
        options: [
          'Искушения - это грех',
          'Искушение может быть побеждено Словом и верой',
          'Нужно бежать от каждой пустыни',
          'Только Иисус может устоять'
        ],
        hint: 'Речь о нашей стратегии против искушений',
        funFact: '⚔️ Иисус показывает нам, как побеждать: Слово Божье + активная вера!'
      }
    },

    32: {
      name: 'Первые Ученики',
      challenge: 'Иисус сказал им: Идите за Мною, и Я сделаю вас ловцами человеков...',
      easy: {
        question: 'Какова была профессия Петра и Андрея?',
        options: ['Пастухи', 'Рыбаки', 'Плотники', 'Мытари'],
        hint: 'Профессия на Галилейском озере',
        funFact: '🎣 Иисус превращает рыбаков рыб в ловцов душ!'
      },
      medium: {
        question: 'Как отреагировали первые ученики на призыв?',
        options: [
          'Долго колебались',
          'Просили доказательств',
          'Оставили все и сразу последовали за Ним',
          'Торговались'
        ],
        hint: 'Немедленный и полный ответ',
        funFact: '🚶 Власть Иисуса была так очевидна, что они повиновались мгновенно!'
      },
      hard: {
        question: 'Что значит следовать за Иисусом в наше время?',
        options: [
          'Оставить работу',
          'Жить по Его учению и воле',
          'Присоединиться к изолированной общине',
          'Только проповедовать'
        ],
        hint: 'Речь о преобразовании жизни и приоритетов',
        funFact: '✨ Следование за Иисусом преображает наши сердца, выборы, судьбу!'
      }
    },

    33: {
      name: 'Нагорная проповедь',
      challenge: 'Блаженны нищие духом, ибо их есть Царство Небесное...',
      easy: {
        question: 'Какое первое блаженство в Нагорной проповеди?',
        options: [
          'Блаженны чистые сердцем',
          'Блаженны нищие духом',
          'Блаженны кроткие',
          'Блаженны миротворцы'
        ],
        hint: 'Относится к духовному смирению',
        funFact: '😊 Нищие духом знают свою нужду в Боге - врата в Царство!'
      },
      medium: {
        question: 'Что сказал Иисус о миротворцах?',
        options: [
          'Они будут счастливы',
          'Они будут наречены сынами Божиими',
          'Они будут любимы',
          'Они будут сильны'
        ],
        hint: 'Особая божественная идентичность',
        funFact: '👑 Миротворцы подобны Богу - живое свидетельство Его природы!'
      },
      hard: {
        question: 'Как блаженства переворачивают ценности мира?',
        options: [
          'Осуждая богатство',
          'Изолируя верующих',
          'Провозглашая благословенными тех, кого мир презирает',
          'Отменяя законы'
        ],
        hint: 'Речь о божественных ценностях, противоположных мирским',
        funFact: '🔄 Блаженства меняют наше видение счастья и успеха!'
      }
    },

    34: {
      name: 'Притчи о Царстве',
      challenge: 'Он учил их притчами многому...',
      easy: {
        question: 'В притче о сеятеле, что представляет собой семя?',
        options: [
          'Деньги',
          'Слово Божие',
          'Добрые дела',
          'Любовь'
        ],
        hint: 'То, что проповедует и учит Иисус',
        funFact: '🌱 Слово Божие прорастает и растет в наших сердцах!'
      },
      medium: {
        question: 'В притче о горчичном зерне, что символизирует это крошечное семя?',
        options: [
          'Человеческую слабость',
          'Царство, которое начинается малым, но становится великим',
          'Важность деталей',
          'Природу'
        ],
        hint: 'Нечто, что растет впечатляющим образом',
        funFact: '🌳 Из самого малого семени вырастает великое дерево - сила Царства!'
      },
      hard: {
        question: 'Почему Иисус учил притчами?',
        options: [
          'Чтобы усложнить Свое послание',
          'Чтобы открыть духовные истины через знакомые образы',
          'Из-за недостатка времени',
          'Чтобы проверить интеллект'
        ],
        hint: 'Речь о том, чтобы сделать тайны Царства доступными',
        funFact: '💡 Притчи открывают открытым сердцам и скрывают от закрытых!'
      }
    },

    35: {
      name: 'Чудеса Иисуса',
      challenge: 'Он укротил бурю и сказал морю: Умолкни! Перестань!...',
      easy: {
        question: 'Сколькими хлебами Иисус накормил 5000 человек?',
        options: ['3 хлеба', '5 хлебов', '7 хлебов', '12 хлебов'],
        hint: 'Столько же, сколько рыб',
        funFact: '🍞 5 хлебов и 2 рыбы становятся пиром - божественная щедрость!'
      },
      medium: {
        question: 'Что сказали ученики, когда Иисус укротил бурю?',
        options: [
          'Он волшебник',
          'Кто это, что и ветер и море повинуются Ему?',
          'Это нормально',
          'Мы должны уйти отсюда'
        ],
        hint: 'Вопрос о личности Иисуса',
        funFact: '⛈️ Даже стихии признают своего Творца и Господа!'
      },
      hard: {
        question: 'Какова главная цель чудес Иисуса?',
        options: [
          'Произвести впечатление на толпы',
          'Явить Свою божественность и показать любовь Бога',
          'Получить влияние',
          'Помочь только материально'
        ],
        hint: 'Речь о божественном откровении и сострадании',
        funFact: '❤️ Каждое чудо открывает сердце Бога: любовь, сострадание, силу!'
      }
    },

    36: {
      name: 'Преображение',
      challenge: 'И преобразился перед ними; лицо Его просияло, как солнце...',
      easy: {
        question: 'Какие ученики видели преображение Иисуса?',
        options: [
          'Все двенадцать',
          'Петр, Иаков и Иоанн',
          'Только Петр и Иоанн',
          'Женщины, следовавшие за Ним'
        ],
        hint: 'Внутренний круг трех',
        funFact: '⛰️ Петр, Иаков и Иоанн: привилегированные свидетели божественной славы!'
      },
      medium: {
        question: 'Какие фигуры Ветхого Завета появились?',
        options: [
          'Авраам и Исаак',
          'Давид и Соломон',
          'Моисей и Илия',
          'Адам и Ной'
        ],
        hint: 'Представитель Закона и Пророков',
        funFact: '📜 Моисей (Закон) и Илия (Пророки) свидетельствуют об Иисусе!'
      },
      hard: {
        question: 'Что это преображение открывает о природе Иисуса?',
        options: [
          'Он великий пророк',
          'Его скрытая божественность временно открывается',
          'Он управляет светом',
          'Он может менять внешность'
        ],
        hint: 'Речь об откровении Его божественной природы',
        funFact: '✨ Божественная слава Иисуса сияет - предвкушение Его воскресения!'
      }
    },

    37: {
      name: 'Торжественный вход',
      challenge: 'Осанна Сыну Давидову! Благословен грядущий во имя Господне!...',
      easy: {
        question: 'На каком животном Иисус въехал в Иерусалим?',
        options: ['Конь', 'Осел', 'Верблюд', 'Пешком'],
        hint: 'Животное, символизирующее смирение и мир',
        funFact: '🐴 Осел символизирует смиренного Царя, идущего с миром, а не на войну!'
      },
      medium: {
        question: 'Что кричала толпа, встречая Иисуса?',
        options: [
          'Да здравствует Царь!',
          'Осанна! Благословен грядущий во имя Господне!',
          'Слава Богу!',
          'Свобода!'
        ],
        hint: 'Возглас радости и благословения',
        funFact: '🌿 "Осанна" значит "спаси сейчас" - призыв к божественному спасению!'
      },
      hard: {
        question: 'Почему этот вход "торжественный", но трагический?',
        options: [
          'Было мало людей',
          'Толпа, приветствующая Его, отвергнет Его через 5 дней',
          'Власти отсутствовали',
          'Шел дождь'
        ],
        hint: 'Речь о непостоянстве человеческого сердца',
        funFact: '💔 Та же толпа будет кричать "Распни Его!" через несколько дней!'
      }
    },

    38: {
      name: 'Тайная вечеря',
      challenge: 'Примите, ядите, сие есть Тело Мое, за вас предаваемое...',
      easy: {
        question: 'Что Иисус сделал с ногами Своих учеников?',
        options: [
          'Благословил их',
          'Умыл их',
          'Помазал их',
          'Поцеловал их'
        ],
        hint: 'Жест смирения и служения',
        funFact: '🦶 Учитель становится слугой - революция любви и смирения!'
      },
      medium: {
        question: 'Что установил Иисус на этой вечере?',
        options: [
          'Крещение',
          'Евхаристию (Причастие)',
          'Молитву "Отче наш"',
          'Пост'
        ],
        hint: 'Таинство с хлебом и вином',
        funFact: '🍞🍷 Хлеб и вино становятся вечными символами жертвы и любви!'
      },
      hard: {
        question: 'Что означает "сие творите в Мое воспоминание"?',
        options: [
          'Повторяйте эту вечерю',
          'Празднуйте Мою смерть и воскресение, пока не приду',
          'Помните Мои слова',
          'Любите друг друга'
        ],
        hint: 'Речь о живом и пророческом воспоминании',
        funFact: '⏳ Каждое причастие возвещает смерть Господню, доколе Он придет!'
      }
    },

    39: {
      name: 'Гефсимания',
      challenge: 'Отче Мой! если возможно, да минует Меня чаша сия...',
      easy: {
        question: 'Где молился Иисус перед арестом?',
        options: [
          'В храме',
          'В Гефсиманском саду',
          'На Елеонской горе',
          'В доме друзей'
        ],
        hint: 'Сад оливковых деревьев',
        funFact: '🫒 Гефсимания означает "масличный пресс" - место сильного давления!'
      },
      medium: {
        question: 'Что делали ученики, пока Иисус молился?',
        options: [
          'Молились с Ним',
          'Спали',
          'Стояли на страже',
          'Ушли'
        ],
        hint: 'Не могли бодрствовать даже один час',
        funFact: '😴 Дух бодр, плоть же немощна - человеческая слабость!'
      },
      hard: {
        question: 'Что агония Иисуса открывает о Его природе?',
        options: [
          'Он был просто человеком',
          'Он был полностью человеком и полностью Богом',
          'Он сомневался в Своей миссии',
          'Он был слаб'
        ],
        hint: 'Речь о тайне Воплощения',
        funFact: '✝️ Иисус полностью несет человеческую муку, оставаясь верным Богу!'
      }
    }
  }
};

export default chapter3Translations;
